import React, { useCallback, useContext, useEffect, useState } from "react";
import { WrapAddWord, WrapWord, Time, WrapResult, FabDetail, WrapWordContent, WrapWordText, WrapSettings, Word, SelectWord, SelectTimePoint, PointTime } from './Style'
import { useSelector } from "react-redux";
import { incorrect } from "keys/types";
import { InsertionIcon, wordHooks, WordSettings } from ".";
import { IconButton } from "components/Form";
import { SvgIcon, Tooltip } from "@mui/material";
import { errorHooks } from "./ErrorTypes";
import { categories, grades, updateType } from "keys";
import { StudentWordListStyles } from './Style'
import { WordsContext } from "./Words";
import { NextButton } from "pages/School/PerformAssessment";
import { ArrowDownward } from "@mui/icons-material";
import { viewResultsSettings } from './hooks/constants'
import { AnimatePresence } from "framer-motion";
import { ReactComponent as ArrowIcon } from 'assets/icons/Arrow.svg';
import * as motion from "motion/react-client"

const StudentWordList = (props) => {
    const { words, settings, visibleType } = props
    const { markOption, viewResults } = settings || {}
    const { hideNextButton, hideDisabledNext, changeBoldWordAfterSeconds, boldWordAfterSeconds, wordListPage, handleNext, setWordListPage, wordListIndex, setWordListIndex, finishPerfom, showCartoon } = useContext(WordsContext)
    const { assessment } = useSelector(state => state.assessment)
    const { testTaker } = useSelector(state => state.testTaker)
    const { grade } = testTaker
    const { endPoint = {}, timePoint = {}, reading_assessment_category_name } = assessment || {}

    const isVowelSound = reading_assessment_category_name === categories.VOWEL_SOUND

    const [currentBoldWord, setCurrectBoldWord] = useState(null)
    const [disabledNext, setDisabledNext] = useState(true)

    const getTooltipTitle = errorHooks.useGetTooltipTitle()
    const wordInsertion = wordHooks.useInsertion()

    const disabledGoPrev = !wordListIndex
    const disabledGoNext = Math.floor(words.length / 9) === Math.abs(wordListPage)

    let gradeStyle = grades[grade] || {}
    if (isVowelSound) {
        gradeStyle = grades[1]
    }
    const { cardHeight, cardWidth } = gradeStyle
    const fontsize = gradeStyle.fontsize?.[visibleType]

    const goNextPage = useCallback(() => {
        setWordListPage(page => page + 1)
        setWordListIndex(index => index - 9)
    }, [])

    const goPrevPage = useCallback(() => {
        setDisabledNext(true)
        setWordListPage(page => page - 1)
        setWordListIndex(index => index + 9)
    }, [])

    useEffect(() => {
        if (boldWordAfterSeconds)
            setTimeout(() => {
                setInterval(() => {
                    setCurrectBoldWord(currentBoldWord => currentBoldWord + 1)
                }, changeBoldWordAfterSeconds)
            }, boldWordAfterSeconds)
    }, [])

    useEffect(() => {
        if (disabledNext)
            setTimeout(() => {
                setDisabledNext(false)
            }, 2000);
    }, [disabledNext])

    return (
        <StudentWordListStyles disabled={true} fontSize={fontsize} cardHeight={cardHeight} cardWidth={cardWidth}>
            <div className="wrap-word-list">
                <div className="wrap-words-and-next-button">
                    <div className="wrap-words">
                        <div className="wrap-example-arrow">
                            <div className="example-arrow">
                                <SvgIcon fontSize="large" component={ArrowIcon} inheritViewBox />
                            </div>
                        </div>
                        {words?.map((word, index) => {
                            const { removed, minorError, word_def_text, customStatus, transcription, status, word_def_fe_details } = word
                            const { break_line } = word_def_fe_details || {}

                            let renderData = true

                            //show only the relevalt words
                            if (!(index >= wordListIndex && index <= wordListIndex + 8))
                                renderData = false
                            else {
                                if (endPoint?.index)
                                    renderData = index <= endPoint.index - 1//index starts with 1 do we need to raise 1

                                if (!viewResults) renderData = true
                                // if (!word.word_def_id) renderData = false
                            }

                            const settingsValues = {
                                error: status === incorrect && !minorError,
                                minorError: minorError,
                                timePoint: timePoint?.word_def_id === word.word_def_id ? timePoint.value : "",
                                end: endPoint.word_def_id === word.word_def_id,
                                customStatus: customStatus,
                                removed: removed
                            }

                            const { error: errorVal, minorError: minorErrorVal, timePoint: timePointVal, end: endVal, customStatus: customStatusVal } = settingsValues

                            const nextWord = words?.[index + 1 < words?.length ? index + 1 : index]

                            let tooltipContent = getTooltipTitle(errorVal, minorError, removed, customStatus)

                            if (renderData)
                                return (
                                    word.word_def_id ?
                                        <div className={`word-content`} key={index} >
                                            <div className="word-item">
                                                {markOption &&
                                                    <WordSettings
                                                        index={index}
                                                        word={word}
                                                        settingsValues={settingsValues}
                                                    />}
                                                {viewResults &&
                                                    <WordSettings
                                                        index={index}
                                                        word={word}
                                                        settings={viewResultsSettings}
                                                    />}
                                                <Tooltip title={tooltipContent} placement="top">
                                                    <div className={`word ${currentBoldWord === index + 1 && `bold-word bold-word-text`}`} $removed={removed} $customStatus={customStatusVal} $minorError={minorErrorVal} $error={errorVal}>
                                                        {isVowelSound &&
                                                            <div className="place-holder">
                                                                {"א"}
                                                            </div>}
                                                        <div className={isVowelSound && `vowel ${(word_def_text != "וֺֹ" && word_def_text != "ִי") && "vowel1"} ${word_def_text == "ֹ" && "special-vowel"}`}>
                                                            {transcription || word_def_text}
                                                        </div>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                            {markOption &&
                                                <WrapAddWord>
                                                    <IconButton
                                                        $bg
                                                        {...wordInsertion}
                                                        color={
                                                            (nextWord.word_def_id || nextWord.update_type == updateType.delete)
                                                                ? "transparent" :
                                                                (nextWord.minorError ? "rating4" : "error")}
                                                        action={() => wordInsertion.action(word, index)}
                                                    />
                                                </WrapAddWord>}

                                            {break_line && <div style={{ width: "100%" }} />}
                                        </div>
                                        :
                                        !markOption &&
                                        <div className="insertion-icon">
                                            <InsertionIcon />
                                        </div>
                                )
                        })}
                    </div>
                    {hideNextButton ||
                        <AnimatePresence>
                            <div className="wrap-go-prev-page">
                                <motion.div
                                    initial={{ opacity: 0.5 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0.5 }}
                                    transition={{ duration: 0.7 }}
                                    key="go-prev-page"
                                >
                                    <div className="go-prev-page">
                                        <NextButton
                                            // disabled={hideDisabledNext ? false : disabledNext}
                                            action={() => {
                                                handleNext ? handleNext() :
                                                    disabledGoNext ? finishPerfom?.() : goPrevPage()
                                            }} />
                                    </div>
                                </motion.div>
                            </div>
                        </AnimatePresence>}
                </div>
            </div>

        </StudentWordListStyles>
    )
}

export default StudentWordList